import { useIsMobile } from 'components/v3';

// Which builder layout the viewport gets (build plan §5.8):
//   mobile  <768        single pane, FAB, sheets, no drag and drop
//   narrow  768–1279    palette | canvas; Properties in a right Drawer
//   wide    ≥1280       palette | canvas | Properties
// hasTopBar: ≤860 the app shell pins its 60px bar, so sticky things
// offset by 60px.
const useBuilderLayout = () => {
  const isMobile = useIsMobile();
  const isNarrow = useIsMobile(1280);
  const hasTopBar = useIsMobile(861);
  let mode = 'wide';
  if (isMobile) mode = 'mobile';
  else if (isNarrow) mode = 'narrow';
  return { mode, isMobile, hasTopBar, stickyTop: hasTopBar ? 76 : 16 };
};

export default useBuilderLayout;
